export default __webpack_public_path__ + "locales/pt-BR/RoomLogoCover.json?hash=9bda371040597f090f1fcfa4350ad35e";